(function() {
	'use strict';

	angular.module('smb-app')
		.factory('smbDocumentHistoryDataStore', ['smbDocumentHistoryService', DocumentHistoryDataStore]);
		
	var tokenRegex = /\[@(.*?)\[\/\]/g; 
	// will capture with User=5]john from [@User=5]john[/]

	/**
	 * @ngdoc service
	 * @name smb-app.smbDocumentNotesDataStore
	 * 
	 * @description
	 * Manages state for the notes for a single document.
	 */
	function DocumentHistoryDataStore(smbDocumentHistoryService) {
		var _history;

		return {
			/**
			 * @ngdoc property
			 * @name smbDocumentNotesDataStore#notes
			 * @propertyOf smb-app.smbDocumentNotesDataStore
			 * @kind property
			 * 
			 * @description
			 * Returns the current collection of notes
			 * 
			 * @returns {DocumentNote[]} An array of @see DocumentNote objects
			 */
			get history() { return _history; },

			/**
			 * @ngdoc method
			 * @name smbDocumentNotesDataStore#loadNotes
			 * @propertyOf smb-app.smbDocumentNotesDataStore
			 * @kind function
			 * 
			 * @description
			 * Loads the document notes for a specific document by id
			 * 
			 * @param {String} documentId The document id
			 * 
			 * @returns {Deferred<DocumentNote[]>} A promise that resolves to a collection of @see DocumentNote objects
			 */
			loadHistory: loadHistory

		};

		function loadHistory(documentId) {
			return smbDocumentHistoryService.getHistory(documentId)
				.then(function(history) {
					
					_history = history.map(function(hi) { 
						var final = hi.Message.replace('&&_AirBase_Assigned_Date', 'assigned date')
						.replace('&&_AirBase_ToDo_Status', 'To Do Status')
						.replace('&&_AirBase_Content_Status', 'Status')
						.replace('&&_AirBase_Assigned_UserId', 'assgined user')
						.replace(/\./g, '');
						return {'Message' : tokenStringFilterReplace(final), 'UserName': hi.UserName, 'ActivityDate': tokenStringExtractDate(final)};
					});
					return _history;
				});
		}

		function tokenStringFilterReplace (str) {
			if (!str) {
				return str;
			}

			return str.replace(tokenRegex, function (token, capture) {
				// the captured text is in the form "User=5]john"
				var parts = capture.split(']');
				var attrPart = parts[0].split('=');
				if (attrPart[0] === 'User') {
					return '';
				}
				if (attrPart[0] === 'Document') {
					return '';
				}
				if (attrPart[0] === 'Action' && attrPart[1] === 'tagged') {
					return 'modified field value on';
				}
				if (attrPart[0] === 'Action' && attrPart[1] === 'untagged') {
					return 'removed field value ';
				}
				if (attrPart[0] === 'Action' && attrPart[1] === 'commented') {
					return 'commented ';
				}
				if (attrPart[0] === 'Date') {
					return '';
				}
				
				var message = parts[1];
				return parts[1];
			});
		}

		function tokenStringExtractDate(str) {
			if (!str) {
				return str;
			}

			var datestring = '';
			str = str.replace(tokenRegex, function (token, capture) {
				// the captured text is in the form "User=5]john"
				var parts = capture.split(']');
				var attrPart = parts[0].split('=');
				if (attrPart[0] === 'Date') {
					datestring = parts[1];
					return parts[1];
				}				
				return '';
			});

			return datestring + '.';
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/dataStores/documentHistoryDataStore.js
// module id = 121
// module chunks = 1